import { render } from "./ClassChecklist.vue?vue&type=template&id=543ece38&scoped=true&ts=true"
import script from "./ClassChecklist.vue?vue&type=script&lang=ts"
export * from "./ClassChecklist.vue?vue&type=script&lang=ts"

import "./ClassChecklist.vue?vue&type=style&index=0&id=543ece38&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543ece38"]])

export default __exports__